import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { users } from '../../../../interfaces/users';
import { EmployeesService } from '../../../../services/employees';
import { FinancialManagerService } from '../../../../services/financial-manager';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss'
})
export class EmployeeComponent {
  userData!: users;
  data!: any;
  id!: any;
  name!: any;
  job_title!: any;
  salary!: any;
  contentReady: boolean = true;
  uniqueDates: string[] = [];
  filteredDate: string = '';
  allRecords: any[] = [];
  bonuses: any[] = [];
  loans: any[] = [];
  deductions: any[] = [];
  filteredRecords: any;
  filteredMonth: any;
  originalBonuses: any[] = [];
  originalLoans: any[] = [];
  originalDeductions: any[] = [];
  uniqueMonths: string[] = [];
  showFinPopUp: boolean = false;
  amount!: any;
  note!: any;
  finId!: any;
  currentMonth!: any;
  userId!: any;
  salaryMonth: any;
   isMobile!: boolean;
  isAr: boolean = localStorage.getItem("language") == "ar";
  constructor(private _router: Router,
    private _userService: UserService,
    private _FinancialManager: FinancialManagerService,
    private _employessService: EmployeesService,
    private route: ActivatedRoute,
        private deviceService: DeviceDetectorService,

  ) { }

  ngOnInit() {
              this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile)
      this._router.navigateByUrl('/employee.mobile');
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    this.currentMonth = `${year}-${month}`;
    this.salaryMonth = this.currentMonth;
    this._userService.getUserId().subscribe({
      next: (data) => {

        this.userId = data['user_id'];

      },
      error: (error) => console.error(error),
    });
    this.route.queryParams.subscribe(params => {
      this.data = params;
      this.id = this.data["id"];
      this.name = this.data["name"];
      this.job_title = this.data["job_title"];
      this.salary = this.data["salary"];

      this.contentReady = false;
    });
    this.getOneEmployee()
  }
  getOneEmployee() {

    this.contentReady = true;

    const today = new Date();
    const todayString = today.toISOString().substring(0, 10);
    const currentMonth = today.toISOString().substring(0, 7);

    this._employessService.getOneEmployees(this.id).subscribe({
      next: (data) => {

        this.contentReady = false;

        // Store original data
        this.originalBonuses = data["bonuses"] || [];
        this.originalLoans = data["loans"] || [];
        this.originalDeductions = data["deductions"] || [];

        // Combine all records
        this.allRecords = [
          ...this.originalBonuses,
          ...this.originalLoans,
          ...this.originalDeductions
        ];

        /* =============================
           Extract Unique Dates
        ============================= */

        const dateSet = new Set(
          this.allRecords.map(rec => rec.created_at.substring(0, 10))
        );

        this.uniqueDates = Array.from(dateSet)
          .sort((a, b) => b.localeCompare(a));


        /* =============================
           Extract Unique Months
        ============================= */

        const monthSet = new Set(
          this.allRecords.map(rec => rec.created_at.substring(0, 7))
        );

        this.uniqueMonths = Array.from(monthSet)
          .sort((a, b) => b.localeCompare(a));


        /* =============================
           Default Salary Month
        ============================= */

        if (this.uniqueMonths.includes(this.currentMonth)) {
          this.salaryMonth = this.currentMonth;
        } else {
          this.salaryMonth = this.uniqueMonths[0] ?? this.currentMonth;
        }


        /* =============================
           Default Filters
        ============================= */

        this.filteredDate = this.uniqueDates.includes(todayString)
          ? todayString
          : this.uniqueDates[0] ?? '';

        this.filteredMonth = this.uniqueMonths.includes(currentMonth)
          ? currentMonth
          : this.uniqueMonths[0] ?? '';


        /* =============================
           Initial Filters
        ============================= */

        if (this.filteredDate) this.filterByDate();
        if (this.filteredMonth) this.filterByMonth();

      },

      error: (error) => console.error(error)
    });
  }
  filterByDate() {
    this.filteredMonth = ''; // Clear month filter
    this.loans = this.originalLoans.filter((l) =>
      l.created_at.startsWith(this.filteredDate)
    );
    this.bonuses = this.originalBonuses.filter((b) =>
      b.created_at.startsWith(this.filteredDate)
    );
    this.deductions = this.originalDeductions.filter((d) =>
      d.created_at.startsWith(this.filteredDate)
    );
  }
  paySalary() {

    const month = this.salaryMonth; // الشهر المختار من dropdown

    /* =============================
       Filter Records
    ============================= */

    const currentBonuses = this.originalBonuses.filter(b =>
      b.created_at?.startsWith(month)
    );

    const currentLoans = this.originalLoans.filter(l =>
      l.created_at?.startsWith(month)
    );

    const currentDeductions = this.originalDeductions.filter(d =>
      d.created_at?.startsWith(month)
    );


    /* =============================
       Calculate Totals
    ============================= */

    const totalBonuses = currentBonuses.reduce(
      (sum, b) => sum + Number(b.amount || 0), 0
    );

    const totalLoans = currentLoans.reduce(
      (sum, l) => sum + Number(l.amount || 0), 0
    );

    const totalDeductions = currentDeductions.reduce(
      (sum, d) => sum + Number(d.amount || 0), 0
    );


    /* =============================
       Net Salary
    ============================= */

    const baseSalary = Number(this.salary || 0);

    const netSalary =
      baseSalary + totalBonuses - totalLoans - totalDeductions;


    /* =============================
       Confirm
    ============================= */

    Swal.fire({
      title: this.isAr ? "متأكد؟" : "Are You Sure?",
      html: this.isAr
        ? `
        الراتب الأساسي: ${baseSalary}<br>
        البونص: ${totalBonuses}<br>
        السلف: ${totalLoans}<br>
        الخصومات: ${totalDeductions}<br>
        <b>الصافي: ${netSalary}</b>
      `
        : `
        Base Salary: ${baseSalary}<br>
        Bonuses: ${totalBonuses}<br>
        Loans: ${totalLoans}<br>
        Deductions: ${totalDeductions}<br>
        <b>Net: ${netSalary}</b>
      `,
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "NO"
    }).then((result) => {

      if (result.isConfirmed) {

        /* =============================
           Save Expense
        ============================= */

        this.addEx(this.name, netSalary, month);

      }

    });

  }
  filterByMonth() {

    // خلي الشهر المختار هو شهر المرتب
    this.salaryMonth = this.filteredMonth;

    // فلترة البيانات
    this.filteredDate = '';

    this.loans = this.originalLoans.filter(l =>
      l.created_at.startsWith(this.filteredMonth)
    );

    this.bonuses = this.originalBonuses.filter(b =>
      b.created_at.startsWith(this.filteredMonth)
    );

    this.deductions = this.originalDeductions.filter(d =>
      d.created_at.startsWith(this.filteredMonth)
    );

  }
  addLoan() {
    this.showFinPopUp = true;
    this.finId = 1;
  }
  addDeduction() {
    this.showFinPopUp = true;
    this.finId = 2;
  }
  addBonuses() {
    this.showFinPopUp = true;
    this.finId = 3;
  }
  close() {
    this.finId = null
    this.showFinPopUp = false;
  }
  addEx(employeeName: any, total: any, month: any) {
    if (month) {
      var bonusPayload = {
        warehouse_id: localStorage.getItem("posId"),
        employee_id: this.userId,
        username: localStorage.getItem("username"),
        amount: total,
        note: employeeName + " - " + month,
        type: "1"
      };

    }
    else {
      var bonusPayload = {
        warehouse_id: localStorage.getItem("posId"),
        employee_id: this.userId,
        username: localStorage.getItem("username"),
        amount: total,
        note: employeeName + " - ",
        type: "2"
      };
    }

    this._FinancialManager.addexpenses(bonusPayload).subscribe({
      next: (data) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تمام" : 'success',
          text: this.isAr ? " المرتب اضاف للمصروفات" : 'Salary payed',
        });
      },
      error: (error) => console.error(error),
    });
  }
  onSubmit() {
    this.contentReady = true;
    const bonusPayload = {
      warehouse_id: localStorage.getItem("posId"),
      amount: this.amount,
      note: this.note
    };
    if (this.finId == 1) {
      this._employessService.addLoan(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()
          this.addEx(this.name, this.amount, null);
        },
        error: (error) => console.error(error),
      });

    }
    else if (this.finId == 2) {
      this._employessService.addDeduction(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()
        },
        error: (error) => console.error(error),
      });

    }
    else {


      this._employessService.addBonus(this.id, bonusPayload).subscribe({
        next: (data) => {
          this.contentReady = false;
          this.getOneEmployee()
          this.close()

        },
        error: (error) => console.error(error),
      });

    }
  }
}
